// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2gX8v","content":"Consent_content__1e4xs","footer":"Consent_footer__3cXv9"};